export default [
  {
    path: '/seedsuite-tags/list',
    name: 'seedsuite-tags',
    component: () => import('@/views/seedsuite-tags/SeedSuiteTags.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Seedsuite Tags',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Seedsuite Tags', active: true }
      ]
    }
  }
]
